import { render, staticRenderFns } from "./pgPurchase.vue?vue&type=template&id=25776c18&scoped=true&"
import script from "./pgPurchase.vue?vue&type=script&lang=js&"
export * from "./pgPurchase.vue?vue&type=script&lang=js&"
import style0 from "./pgPurchase.vue?vue&type=style&index=0&id=25776c18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25776c18",
  null
  
)

export default component.exports